import { createAsyncTypes } from 'utils/ActionCreator'

export const ALERTS_SETTINGS_REQUEST_ASYNC = createAsyncTypes(
  'ALERTS_SETTINGS_REQUEST',
  'Settings/Alerts/ShowAlerts'
)
export const UPDATE_ALERTS_SETTINGS_REQUEST_ASYNC = createAsyncTypes(
  'UPDATE_ALERTS_SETTINGS_REQUEST',
  'Settings/Alerts/ShowAlerts'
)

export const REMOVE_CERTIFICATE_REQUEST_ASYNC = createAsyncTypes(
  'REMOVE_CERTIFICATE_REQUEST',
  'Settings/Alerts/ShowAlerts'
)

export const SIEM_PROTOCOL_VALUES = {
  TCP: 1,
  UDP: 2,
  'TLS/SSL': 3,
  Splunk: 5,
  'CrowdStrike NG-SIEM': 6,
}

export const SIEM_LOG_FORMAT_VALUES = {
  'CEF (Arcsight)': 1,
  'Key-Value (Splunk)': 2,
  'LEEF (QRadar)': 3,
  'RFC 3164': 4,
  'RFC 5424': 5,
  'CEF with PRI': 6,
  Sumologic: 7,
  'CrowdStrike NG-SIEM': 8,
}

export const SHOW_ACCESS_TOKEN_OPTIONS = ['RFC 3164', 'RFC 5424', 'Sumologic']
